import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';

import { createStructuredSelector } from 'reselect';
import { HBox, VBox } from '../../../components/Box';
import { setVehicleProperty } from '../actions';
import { AddPhotoButton } from '../../../components/AddPhotoButton';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_ADD_DOCUMENT, REQUEST_DELETE_DOCUMENT } from '../../Companies/constants';
import { Loader } from '../../../components/Loader';
import { addDocument, deleteDocument } from '../../Documents/actions';
import { resizeAndRotate } from '../../../utils/image';
import { Left, Times } from '../../../components/Icon';
import { Button } from '../../../components/Buttons';
import { isMobileDevice } from '../../../utils/checkDevice';

const Container = styled.div`
  .modal-inner {
  }

  width: 100%;

  .multi-img {
    width: 33%;

    height: ${props => (props.imageHeight ? props.imageHeight : '120px')};
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
  }

  .optionPhoto {
    position: fixed;
    background-color: black;
    z-index: 9999;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
`;

const STATE = {
  sort: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehiclePhotoUploaderComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  reset() {
    this.setState({ ...STATE });
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: this.props.photoIndex + '_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  handlePhotoDelete = (documentId, isFromState) => {
    if (confirm()) {
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderPhoto() {
    if (!this.state.renderPhoto) return null;

    if (this.props.workDoc || this.props.workUpdate) return <Loader small />;

    let document = this.props.vehicle.documents?.find(document => document.id == this.state.renderPhoto);

    if (!document) {
      document = this.state.attentionIncidentPhoto?.find(photo => photo?.name == this.state.renderPhoto);
    }
    const isFromStateDoc = document?.name == this.state.renderPhoto;

    const documentId = isFromStateDoc ? document?.id : document?.id;

    return (
      <div
        onClick={this.setStateFn({ renderPhoto: null })}
        className="optionPhoto"
        style={{
          width: Math.ceil(this.state.renderPhotoDims.width) + 'px',
          height: '100%',
          left: Math.ceil(this.state.renderPhotoDims.x) + 'px',
          top: 0,
        }}
      >
        <div
          className="img"
          style={{ backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
        <HBox>
          <Button onClick={this.setStateFn({ renderPhoto: null })}>
            <Left /> {this.lbl('back')}
          </Button>
          <Button
            onClick={() => {
              this.handlePhotoDelete(documentId, isFromStateDoc);
            }}
          >
            <Times />
            {this.lbl('delete')}
          </Button>
        </HBox>
      </div>
    );
  }

  renderKanbanPhotos(attentionType, index) {
    const v = this.props.vehicle;

    if (!v) return null;

    if (this.props.workVehicle || this.props.workUpdate) return <Loader small />;

    let photoIndex = this.props.photoIndex;
    let type = this.props.photoType;

    let photos = v.documents?.filter(d => {
      return d?.type == `${photoIndex}_${type}`;
    });

    let allPhotos = [...photos];

    return (
      <VBox>
        <br />
        <AddPhotoButton onUpload={e => this.capture(type)} key={index} />
        <HBox left flexWrap gap={2}>
          {allPhotos
            .filter(photo => photo?.url)
            ?.map(({ url, name, id }) => {
              return (
                <div
                  key={url}
                  className="multi-img"
                  style={{ backgroundImage: `url('${encodeURI(decodeURI(url)).replace(/%5C/g, '/')}')` }}
                  onClick={() => {
                    let container = window.document.getElementsByClassName('modal-inner')[0];
                    let renderPhotoDims = container.getBoundingClientRect();
                    renderPhotoDims.height = window.innerHeight;
                    this.setState({
                      renderPhoto: name || id,
                      renderPhotoDims,
                    });
                    if (allPhotos?.length == 1) {
                      this.setState({ disableDeletePhoto: true });
                    } else {
                      this.setState({ disableDeletePhoto: false });
                    }
                  }}
                ></div>
              );
            })}
        </HBox>
      </VBox>
    );
  }

  render() {
    return (
      <Container className="modal-inner" imageHeight={this.props.imageHeight}>
        {this.renderPhoto()}
        {this.renderKanbanPhotos()}
      </Container>
    );
  }
}

VehiclePhotoUploaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workDoc: selectWorks([REQUEST_ADD_DOCUMENT, REQUEST_DELETE_DOCUMENT]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicle.id, 'vehicle', id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclePhotoUploader = compose(withConnect, withRouter)(VehiclePhotoUploaderComp);
